import { CurrencyText, TranslatedText } from "@/components/common/text";
import { getNumberWithCommas } from "@/utils/text";
import { useCounterOffer } from "@/hooks/useCounterOffer";

export const LoadCounterOfferPanel = ({ offer, onDone }) => {
    const { acceptCounter, rejectCounter, isLoading, error } = useCounterOffer();
    const loadOfferRate = offer.loadBoardItem?.offerRate;
    const offerRate = offer.offerRate;

    return (
        <div className="flex flex-col gap-3">
            <div className="w-full text-sm/[22px] text-cm-p-text-primary p-3 bg-cm-p-surface-container rounded-lg inline-flex flex-wrap gap-1">
                <TranslatedText>Your</TranslatedText>
                {loadOfferRate !== offerRate ? (
                    <CurrencyText
                        num={loadOfferRate}
                        round
                        className="text-sm/[22px] font-medium text-cm-p-text-secondary line-through"
                    />
                ) : null}
                <CurrencyText num={offerRate} round className="text-sm/[22px] font-medium text-cm-p-text-primary" />
                <TranslatedText>bid has been countered to</TranslatedText>
                <CurrencyText num={offer.counterRate} round className="text-sm/[22px] font-medium text-cm-p-text-primary" />.
            </div>
            <div className="flex flex-row gap-3">
                <button
                    type="button"
                    disabled={isLoading}
                    onClick={() => rejectCounter(offer, onDone)}
                    className="flex-1 h-11 rounded-lg bg-cm-p-container-red text-cm-p-on-container-red font-medium text-sm/[22px] disabled:opacity-30 inline-flex items-center justify-center"
                >
                    <TranslatedText>Decline</TranslatedText>
                </button>
                <button
                    type="button"
                    disabled={isLoading}
                    onClick={() => acceptCounter(offer, onDone)}
                    className="flex-1 h-11 rounded-lg bg-cm-p-accent-500 text-cm-p-neutral-dark-500 font-medium text-sm/[22px] disabled:opacity-30 inline-flex items-center justify-center gap-1"
                >
                    <TranslatedText>Accept</TranslatedText> ${getNumberWithCommas(offer.counterRate, true)}
                </button>
            </div>
            {error ? <div className="text-cm-error text-sm/[22px]">{error}</div> : null}
        </div>
    );
};
